import Emitter from "./Emitter";

export default class OpenHelp extends Emitter {
    constructor(gb) {
        super(gb);
    }

    LNWOGS_handler() {
        this.gb.wallet.openHelp();
    }

    _default() {
        return
    }
}
